import React, { useEffect, useState } from 'react'
import { Row } from 'react-bootstrap'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import FilterContext from '../contexts/FilterContext'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../actions/userActions'
import { COLORS } from '../constants/colors'


function ShoppingCartScreen() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const { cartReducers: { error } } = useSelector(state => state)

    const [selectedOrders, setSelectedOrders] = useState([])

    const location = useLocation()
    
    useEffect(() => {
        if(location.pathname === '/shopping-cart'){
            setSelectedOrders([])
        }
    }, [location.pathname])

    // Handle authentication error
    useEffect(() => {
        if (error && error.includes('Authentication credentials were not provided')) {
            // Log out the user and redirect to home page
            dispatch(logout())
            navigate('/')
        }
    }, [error, dispatch, navigate])

    return (
        <>
        <FilterContext.Provider value={{selectedOrders, setSelectedOrders}}>
            <Row className='mx-3'>
                <Outlet />
            </Row>
        </FilterContext.Provider>
        </>
    )
}

export default ShoppingCartScreen
